import React from "react";

const ScheduleFieldWrapper = ({ label, required, children }) => {
  return (
    <fieldset className="w-full m-auto text-lg">
      <div className="border border-grayLight rounded w-full uppercase p-2 text-xs">
        <div className="flex flex-row">
          <label className="font-semibold font-inter text-sm text-[#393636]">
            {label}
          </label>
          {required && <span className="text-red-500 ml-1">*</span>}
        </div>

        <div className="mt-1 flex justify-between">{children}</div>
      </div>
    </fieldset>
  );
};

export default ScheduleFieldWrapper;
